import Api from '../../services/Api';

let productsLoadSeq = 0;

export default {
  state: {
    selected: {
      correct: null,
      protect: null,
      optimize: null,
    },
    isCompareMode: false,
    showDashes: true,
    userIsSet: false,
    productLoaded: false,
    rangeLoaded: false,
    products: [],
    ranges: [],
    progressiveProductsConfiguration: [
      {
        id: 'VARILUX-PHYSIO-EXTENSEE',
        contrast: 1,
        sharpness: 1,
      },
      {
        id: 'VARILUX-XR-SERIES',
        contrast: 1,
        sharpness: 1,
      },
      {
        id: 'VARILUX-X-SERIES',
        contrast: 1,
        sharpness: 1,
      },
      {
        id: 'VARILUX-S-SERIES',
        contrast: 1,
        sharpness: 1,
      },
      {
        id: 'VARILUX-I-PLUS-SERIES',
        contrast: 1,
        sharpness: 1,
      },
      {
        id: 'VARILUX-E-SERIES',
        contrast: 2,
        sharpness: 2,
      },
      {
        id: 'PROG-ESSILOR-PREMS',
        contrast: 2,
        sharpness: 2,
      },
      {
        id: 'PROG-ESSILOR-INIZIO',
        contrast: 2,
        sharpness: 2,
      },
      {
        id: 'PROG-ESSILOR-AMATSI',
        contrast: 2,
        sharpness: 2,
      },
      {
        id: 'PROG-ESSILOR-EXCLUSIFS-HD-PLUS',
        contrast: 2,
        sharpness: 2,
      },
      {
        id: 'PROG-ESSILOR-EXCLUSIFS-HD',
        contrast: 2,
        sharpness: 2,
      },
      {
        id: 'PROG-ESSILOR-AMATSI-XTRA',
        contrast: 2,
        sharpness: 2,
      },
      {
        id: 'PROG-ESSILOR-SYMPHONY',
        contrast: 2,
        sharpness: 2,
      },
      {
        id: 'VARILUX-PHYSIO',
        contrast: 1,
        sharpness: 1,
      },
      {
        id: 'VARILUX-COMFORT',
        contrast: 1,
        sharpness: 1,
      },
      {
        id: 'VARILUX-COMFORT-MAX',
        contrast: 1,
        sharpness: 1,
      },
      {
        id: 'VARILUX-LIBERTY',
        contrast: 1,
        sharpness: 1,
      },
      {
        id: 'PROG-STANDARD',
        contrast: 3,
        sharpness: 3,
      },
    ],
    crizalProductsConfiguration: [
      {
        value: 4,
        id: 'CRIZAL-NATURAL-LOOK',
        name: 'Crizal® Natural look',
      },
      {
        value: 5,
        id: '',
        name: 'Verre sans traitement',
      },
    ],
    comparisonProductLeft: null,
    comparisonProductRight: null,
  },
  actions: {
    sendEmail({ commit }, data) {
      commit('SEND_EMAIL', data);
    },

    acceptCgu({ dispatch }) {
      return Api.acceptCgu().then(async response => {
        const payload = response && response.data;
        const acceptedAt = payload && (payload.cgutAcceptedAt || payload.cguAcceptedAt);
        window.sessionStorage.setItem('cgu', acceptedAt || new Date().toISOString());
        await dispatch('loadProducts');
      });
    },
    loadProducts({ commit }) {
      const requestId = ++productsLoadSeq;
      const requestedStoreId = window.sessionStorage.getItem('storeId');
      let productsTemp = [];
      return (
        Api.getGammes()
          .then(r => r.data)
          //   .then(copyProductsInsideRanges)
          .then(ranges => {
            if (requestId !== productsLoadSeq) return false;
            if (requestedStoreId !== window.sessionStorage.getItem('storeId')) return false;
            if (!ranges || !Array.isArray(ranges.ranges)) return false;
            const acceptedAt = ranges.cgutAcceptedAt || ranges.cguAcceptedAt;
            if (acceptedAt) {
              window.sessionStorage.setItem('cgu', acceptedAt);
            } else {
              window.sessionStorage.removeItem('cgu');
            }
            commit('SET_PODIUM', ranges.isPodium);
            commit('SET_RANGES', ranges.ranges);
            ranges.ranges.forEach(range => {
              if (range.products) {
                range.products.forEach(product => {
                  productsTemp.push(product);
                });
              }
            });
            commit('SET_PRODUCTS', productsTemp);
            return true;
          })
          .catch(error => {
            console.error(error);
            return false;
          })
      );
    },
  },
  mutations: {
    SEND_EMAIL(state, data) {
      Api.sendEmail(data)
        .then(success => {
          return success;
        })
        .catch(error => {
          this.$log.error(error);
        });
    },
    SET_PODIUM(state, podium) {
      state.isPodium = podium;
    },
    SET_PRODUCTS(state, products) {
      state.products = products;
      state.productLoaded = true;
    },
    SET_RANGES(state, ranges) {
      state.ranges = ranges;
      state.rangeLoaded = true;
    },
    selectProduct(state, { category, productId }) {
      state.selected[category] = productId;
      if (productId) {
        window.localStorage.setItem(`cpo_${category}`, productId);
      } else {
        window.localStorage.removeItem(`cpo_${category}`);
      }
    },
    setComparisonProductLeft: (state, product) => {
      state.comparisonProductLeft = product;
    },
    setComparisonProductRight: (state, product) => {
      state.comparisonProductRight = product;
    },
    setCompareMode(state) {
      state.isCompareMode = !state.isCompareMode;
    },
    setUser(state) {
      state.userIsSet = !state.userIsSet;
    },
    setShowDashes(state) {
      state.showDashes = !state.showDashes;
    },
  },
  getters: {
    isPodiumActive: state => () => {
      return state.isPodium;
    },
    // get products by filtering with category
    productsByCategory: state => category => {
      return state.products.filter(product =>
        product
          ? product.category ===
          category /* TODO ALE : filtrer au niveau du Range ?  &&
        state.ranges.find(range => range.id === product.rangeId).isActive*/
          : false
      );
    },

    productsByType: state => category => {
      // add filter to Varilux Immersia because demo doesn't exist 
      return state.products.filter(product => product.rangeId === category && product.name !== 'Varilux Immersia');
    },

    isProductsLoaded: state => () => {
      return state.productLoaded;
    },

    // get products by filtering with demoId
    getProductByDemoId: state => demoId => {
      let currentProduct = null;

      state.products.forEach(product => {
        if (product.demos) {
          product.demos.forEach(demo => {
            if (demo.id == demoId) {
              currentProduct = product;
            }
          });
        }
      });
      return currentProduct;
    },
    getComparisonProducts: (state, getters) => demoId => {
      const product = getters.getProductByDemoId(demoId);
      if (product && product.rangeId) {
        let products = getters.productsByType(product.rangeId);
        // For Varilux, add contrast/sharpness data
        if (product.rangeId === 'VARILUX') {
          products.push({
            id: 'PROG-STANDARD',
            name: 'Verre progressif standard',
            rangeId: 'VARILUX',
            rank: products.length + 1,
          });

          products.forEach(product => {
            const productConfig = state.progressiveProductsConfiguration.find(p => p.id === product.id);
            if (productConfig) {
              product.contrast = productConfig.contrast;
              product.sharpness = productConfig.sharpness;
            }
          });
        }

        return products;
      }

      return null;
    },
    product360: (state, getters) => {

      let products = getters.productsByType('VARILUX');
      products = products.concat(getters.productsByType('PROG-ESSILOR'));
      // For Varilux, add contrast/sharpness data
      products.push({
        id: 'PROG-STANDARD',
        name: 'Verre progressif standard',
        rangeId: 'VARILUX',
        rank: products.length + 1,
      })

      products.forEach(product => {
        const productConfig = state.progressiveProductsConfiguration.find(p => p.id === product.id);
        if (productConfig) {
          product.contrast = productConfig.contrast;
          product.sharpness = productConfig.sharpness;
        }
      });

      return products;
    },
    getSituationLink: state => situationId => {
      var currentSituation = {};
      var demoId = '';

      state.products.forEach(product => {
        if (product.demos) {
          product.demos.forEach(demo => {
            if (demo.situations) {
              demo.situations.forEach(situation => {
                if (situation.id == situationId) {
                  demoId = demo.id;
                  currentSituation = situation;
                }
              });
            }
          });
        }
      });
      return `/demos/${demoId}/${currentSituation.media.type}/${currentSituation.id}`;
    },
    getDemoLink: state => demoId => {
      var situations = [];
      state.products.forEach(product => {
        if (product.demos) {
          product.demos.forEach(demo => {
            if (demo.situations && demo.id === demoId) {
              Array.prototype.push.apply(situations, demo.situations);
            }
          });
        }
      });
      return `/demos/${demoId}/${situations[0].media.type}/${situations[0].id}`;
    },

    getFirstSituationByDemo: state => demoId => {
      var situations = [];
      state.products.forEach(product => {
        if (product.demos) {
          product.demos.forEach(demo => {
            if (demo.situations && demo.id == demoId) {
              Array.prototype.push.apply(situations, demo.situations);
            }
          });
        }
      });

      return situations[0];
    },
    getDemoById: state => demoId => {
      let currentDemo = null;
      state.products.forEach(product => {
        if (product.demos) {
          product.demos.forEach(demo => {
            if (demo.id == demoId) {
              currentDemo = demo;
            }
          });
        }
      });
      return currentDemo;
    },
    getProductById: state => productId => {
      return state.products.find(product => product.id === productId);
    },
    getSituationById: state => situationID => {
      var situations = [];
      state.products.forEach(product => {
        if (product.demos) {
          product.demos.forEach(demo => {
            if (demo.situations) {
              Array.prototype.push.apply(situations, demo.situations);
            }
          });
        }
      });

      return situations.filter(situation => situation.id == situationID);
    },
    productsByBrand: state => brand => {
      return state.products.filter(product => {
        product ? product.name.includes(brand) : false;
      });
    },

    getTransitionsForTintsDemo: state => () => {
      var produits = [];
      state.ranges.forEach(range => {
        if (range.id.includes('TRANSITION')) {
          if (range.products) {
            range.products.forEach(product => {
              if (product.productTints) {
                produits.push(product);
              }
            });
          }
        }
      });

      return produits;
    },

    getRanges: state => () => {
      return state.ranges;
    },
    progressiveProductsConfiguration: state => () => {
      return state.progressiveProductsConfiguration;
    },

    // get demos assiociated with products
    demosByProduct: state => productId => {
      const product = state.products.find(product => {
        return product ? product.id == productId : false;
      });
      return product && product.demos ? product.demos : [];
    },
    getProductSelected: state => {
      try {
        state.selected = {
          correct: state.selected.correct || window.localStorage.getItem('cpo_correct'),
          protect: state.selected.protect || window.localStorage.getItem('cpo_protect'),
          optimize: state.selected.optimize || window.localStorage.getItem('cpo_optimize'),
        };
      } catch {
        // Nothing to do.
      }

      return state.selected;
    },
    // demos for selected products
    selectedProducts: state => {
      return state.products.filter(product => product.id == state.selected[product.category]);
    },
    comparisonProductLeft: state => {
      return state.comparisonProductLeft;
    },
    comparisonProductRight: state => {
      return state.comparisonProductRight;
    },
    isCompareMode: state => {
      return state.isCompareMode;
    },
    userIsSet: state => {
      return state.userIsSet;
    },
    showDashes: state => {
      return state.showDashes;
    },
  },
};

// function copyProductsInsideRanges(data) {
//   let ranges = {
//     ranges: jsonpath.query(data, "$.Range")[0].map(range => {
//       let rangeWithProducts = range;
//       try {
//         rangeWithProducts = {
//           id: range.id,
//           isActive: range.isActive,
//           products: jsonpath.query(
//             data,
//             `$.Product[?(@.rangeId=="${range.id}")]`
//           )
//         };
//       } catch (ex) {
//         this.$log.error("ERROR", ex);
//       }

//       return rangeWithProducts;
//     })
//   };

//   return ranges;
// }
